/** @format */

import { axiosCalls } from '../../config/AxiosCall';
import {
  AddressDto,
  ApplicantCreateDto,
  DocumentDto,
  DocumentsViewDto,
  InstitutionDto,
  LegalGuardianDetailPostDto,
  PersonalDetailsDto,
  StudyDetailsDto,
} from './Models';

const url = 'Applicant';

export async function fetchApplicantById(applicantId: number) {
  return axiosCalls.get(
    `${url}/get-applicant-by-id?applicantId=${applicantId}`
  );
}

export async function fetchAllApplicants() {
  return axiosCalls.get(`${url}/all-applicants`);
}

export async function addApplicant(payload: ApplicantCreateDto) {
  return axiosCalls.post(payload, `${url}/add-applicant`);
}

export async function addPersonalDetails(payload: PersonalDetailsDto) {
  return axiosCalls.post(payload, `${url}/add-personal-details`);
}

export async function fetchApplicantByIdentityNumber(identityNumber: string) {
  return axiosCalls.get(
    `${url}/get-applicant-by-identity-number?identityNumber=${identityNumber}`
  );
}

export async function addAddressDetails(payload: AddressDto) {
  return axiosCalls.put(payload, `${url}/update-address`);
}

export async function loginApplicant() {
    return axiosCalls.post(null,`${url}/applicant-login`);
}

export async function addEducationDetails(payload: InstitutionDto) {
  return axiosCalls.post(payload, `${url}/add-education`);
}

export async function addStudyDetails(payload: StudyDetailsDto) {
  return axiosCalls.post(payload, `${url}/add-institution-study`);
}

export async function addGuardian(payload: LegalGuardianDetailPostDto) {
  return axiosCalls.post(payload, `${url}/add-guardians`);
}

export async function uploadDocuments(payload: DocumentDto[]) {
  return axiosCalls.post(payload, `${url}/upload-documents`);
}

export async function deleteProfile(identityNumber: string) {
  return axiosCalls.delete(
    `${url}/delete-profile?identityNumber=${identityNumber}`
  );
}

export async function uploadSingleDocument(payload: DocumentsViewDto) {
  return axiosCalls.post(payload, `${url}/upload-single-document`);
}

export async function submitApplication(payload: DocumentsViewDto[]) {
  return axiosCalls.post(payload, `${url}/submit-application`);
}

export async function sendEmailSaveApplication() {
  return axiosCalls.get(`${url}/send-email-saved-application`);
}

export async function deleteDocument(doumentId:number) {
  return axiosCalls.delete(`${url}/delete-document?documentId=${doumentId}`);
}

